import {
  validateEmail,
  validatePdfOrWord,
  validateRequired,
  Validator,
  validate5MbMaxFileSize,
} from 'application/utils/validators';

// eslint-disable-next-line max-len
export const SUBMIT_FORM_SUBMIT_RESUME = '[form] submit submit resume';
export type SubmitForm = {
  type: typeof SUBMIT_FORM_SUBMIT_RESUME;
}
export const submitForm = {
  type: SUBMIT_FORM_SUBMIT_RESUME,
};

// eslint-disable-next-line max-len
export const SET_FORM_LOADING_SUBMIT_RESUME = '[forms] set loading submit resume';
export type SetFormLoading = {
  type: typeof SET_FORM_LOADING_SUBMIT_RESUME;
  payload: {
    isLoading: boolean;
  }
};

export const setFormLoading = (
  isLoading: boolean,
): SetFormLoading => ({
  type: SET_FORM_LOADING_SUBMIT_RESUME,
  payload: {
    isLoading,
  },
});

// eslint-disable-next-line max-len
export const SET_FORM_SUCCESS_SUBMIT_RESUME = '[forms] set success submit resume';
export type SetFormSuccess = {
  type: typeof SET_FORM_SUCCESS_SUBMIT_RESUME;
  payload: {
    isSuccess: boolean;
  }
};

export const setFormSuccess = (
  isSuccess: boolean,
): SetFormSuccess => ({
  type: SET_FORM_SUCCESS_SUBMIT_RESUME,
  payload: {
    isSuccess,
  },
});

// eslint-disable-next-line max-len
export const SET_INPUT_SUBMIT_RESUME = '[forms] input change submit resume';

export type SetInput = {
  type: typeof SET_INPUT_SUBMIT_RESUME;
  payload: {
    fieldName: string;
    value?: string | File | undefined;
    validators: Validator[];
  }
}
export type SetInputValidated = {
  type: typeof SET_INPUT_SUBMIT_RESUME;
  payload: {
    [fieldName: string]: {
      value?: string | File;
      error: string;
    }
  }
}

export const setInput = (fieldName: string) => (
  value?: string | File,
): SetInput => ({
  type: SET_INPUT_SUBMIT_RESUME,
  payload: {
    fieldName,
    value,
    validators: [],
  },
});

export const setRequiredInput = (fieldName: string) => (
  value?: string,
): SetInput => ({
  type: SET_INPUT_SUBMIT_RESUME,
  payload: {
    fieldName,
    value,
    validators: [validateRequired],
  },
});
export const setRequiredEmail = (fieldName: string) => (
  value: string,
): SetInput => ({
  type: SET_INPUT_SUBMIT_RESUME,
  payload: {
    fieldName,
    value,
    validators: [validateRequired, validateEmail],
  },
});
export const setRequiredPdfOrWordFile = (fieldName: string) => (
  value?: File,
): SetInput => ({
  type: SET_INPUT_SUBMIT_RESUME,
  payload: {
    fieldName,
    value,
    validators: [validateRequired, validatePdfOrWord, validate5MbMaxFileSize],
  },
});

// eslint-disable-next-line max-len
export const SET_CHECKBOX_SUBMIT_RESUME = '[forms] checkbox change resume submissions';

export type SetCheckbox = {
  type: typeof SET_CHECKBOX_SUBMIT_RESUME;
  payload: {
    groupName: string;
    option: string;
    isChecked: boolean;
    validators: Validator[];
  }
}
export type SetCheckboxValidated = {
  type: typeof SET_CHECKBOX_SUBMIT_RESUME;
  payload: {
    [groupName: string]: {
      value: { [key: string]: boolean; };
      error: string;
    }
  }
}
export const setRequiredCheckbox = (
  groupName: string,
  option: string,
) => (
  isChecked: boolean,
): SetCheckbox => ({
  type: SET_CHECKBOX_SUBMIT_RESUME,
  payload: {
    groupName,
    option,
    isChecked,
    validators: [validateRequired],
  },
});

// eslint-disable-next-line max-len
export const SET_PHONE_INPUT_SUBMIT_RESUME = '[forms] phone number change submit resume';
export type SetPhoneInput = {
  type: typeof SET_PHONE_INPUT_SUBMIT_RESUME;
  payload: {
    countryCode: string;
    number: string;
    isRequired: boolean;
  }
}
export type SetPhoneInputValidated = {
  type: typeof SET_PHONE_INPUT_SUBMIT_RESUME;
  payload: {
    phoneNumber: {
      countryCode: string;
      number: string;
      error: string;
    };
  }
}

export const setRequiredPhoneInput = (
  countryCode: string,
  number: string,
): SetPhoneInput => ({
  type: SET_PHONE_INPUT_SUBMIT_RESUME,
  payload: {
    countryCode,
    number,
    isRequired: true,
  },
});

// eslint-disable-next-line max-len
export const SET_GENERAL_ERROR_SUBMIT_RESUME = 'set general error submit resume';
export type SetGeneralErrorMessage = {
  type: typeof SET_GENERAL_ERROR_SUBMIT_RESUME;
  payload: string;
}

export const setGeneralErrorMessage = (
  message: SetGeneralErrorMessage['payload'],
): SetGeneralErrorMessage => ({
  type: SET_GENERAL_ERROR_SUBMIT_RESUME,
  payload: message,
});

export const RESET_FORM_SUBMIT_RESUME = '[submit-resume] form reset';
export type ResetForm = {
  type: typeof RESET_FORM_SUBMIT_RESUME,
};

export const resetForm: ResetForm = {
  type: RESET_FORM_SUBMIT_RESUME,
};

export type SubmitResumeActions =
| SetInputValidated
| SetPhoneInputValidated
| SetFormLoading
| SetFormSuccess
| SetCheckboxValidated
| SetGeneralErrorMessage
| ResetForm;
